import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      'The transfer is now being processed, which may take up to 24 hours. It will only be executed at the end of this process.',
    heading: 'The transfer request has been approved',
  },
  fr: {
    description:
      "Le virement est maintenant en cours de traitement, ce qui peut prendre jusqu'à 24 heures. Il ne sera exécuté qu’à la fin de ce processus.",
    heading: 'La demande de virement a été validée',
  },
} as const);

export default locales;
